import { PieChart, Pie, Tooltip, ResponsiveContainer } from "recharts";

const DEFAULT_PALETTE = [
  "#6366f1", "#06b6d4", "#f59e0b", "#10b981",
  "#ec4899", "#8b5cf6", "#14b8a6", "#f97316",
  "#3b82f6", "#a855f7",
];

const PieChartCard = ({ data, colors = [], theme, size = 280, compact = false }) => {
  const palette = colors.length > 0 ? colors : DEFAULT_PALETTE;

  const chartData = data.map((d, i) => ({
    name: d.symbol,
    value: parseFloat(d.percent.toFixed(1)),
    fill: palette[i % palette.length],
  }));

  const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, name }) => {
    if (percent < 0.06) return null;
    const RADIAN = Math.PI / 180;
    const r = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + r * Math.cos(-midAngle * RADIAN);
    const y = cy + r * Math.sin(-midAngle * RADIAN);
    return (
      <g>
        <text
          x={x}
          y={compact ? y : y - 7}
          fill="#fff"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={compact ? 10 : 13}
          fontWeight={700}
        >
          %{(percent * 100).toFixed(0)}
        </text>
        {!compact && (
          <text
            x={x}
            y={y + 9}
            fill="rgba(255,255,255,0.75)"
            textAnchor="middle"
            dominantBaseline="central"
            fontSize={11}
          >
            {name}
          </text>
        )}
      </g>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={size}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          innerRadius={compact ? "28%" : "36%"}
          outerRadius={compact ? "50%" : "58%"}
          dataKey="value"
          labelLine={false}
          label={renderLabel}
          paddingAngle={chartData.length > 1 ? 2 : 0}
          stroke="transparent"
        />

        <Tooltip
          formatter={(v, name) => [`%${v}`, name]}
          contentStyle={{
            background: theme?.card || "#1e293b",
            border: "none",
            borderRadius: 10,
            boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
            color: theme?.text || "#f0f4f8",
            fontWeight: 600,
            fontSize: 13,
          }}
          itemStyle={{ color: theme?.text || "#f0f4f8" }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PieChartCard;
